const combineParentCategoriesWithChild = (categories) => {
	return categories.map((item) => {
		if (item.parentId === null) {
			item.types = []
			categories.forEach((category) => {
				if (category.parentId === item.id) {
					item.types.push(category)
				}
			})
		}
		return item
	})
}

export default combineParentCategoriesWithChild
